import { render, staticRenderFns } from "./forwardBidding.vue?vue&type=template&id=90c8e798&scoped=true&"
import script from "./forwardBidding.vue?vue&type=script&lang=js&"
export * from "./forwardBidding.vue?vue&type=script&lang=js&"
import style0 from "./forwardBidding.vue?vue&type=style&index=0&id=90c8e798&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c8e798",
  null
  
)

export default component.exports